import { Box, ColorOptions, Image, Text } from '@jfs/ui-new'
import { useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { shadowStyle } from '../../util/util'
import { styles } from './styles'

export const UsernameHoverModal = ({ data, rowData }: any) => {
  const bgStyle = styles[`${data}`?.toLowerCase()] ?? styles.defaultCell
  const parentViewRef = useRef(null)
  const textStyles = styles.title
  const [hoverViewVisible, setHoverViewVisible] = useState(false)
  const pos = useRef({ left: undefined, top: undefined })

  const renderUsername = () => {
    if (!hoverViewVisible) {
      return null
    }
    const getTop = () => {
      const topPos = pos.current?.top ?? 0
      return topPos - 60
    }
    const getLeft = () => {
      const leftPos = pos.current?.left ?? 0
      return leftPos - 8
    }
    return (
      <Box
        bg={'TRANSPARENT'}
        w={'100%'}
        h={'100%'}
        position={'absolute'}
        top={0}
        left={0}
        underlayColor={'TRANSPARENT'}
        testID="close-hoverViewVisible"
        onPress={() => setHoverViewVisible(false)}>
        <Box
          {...shadowStyle}
          bg={'#7C7C7C' as ColorOptions}
          left={getLeft()}
          top={getTop()}
          w={140}
          h={50}
          pl={8}
          onPress={() => null}
          zIndex={10000}
          justify={'center'}
          flexDirection="row"
          alignItems={'center'}
          borderRadius={4}>
          <Image source={require('../../assets/images/ic_user.png')} width={'24'} height={'24'} />
          <Box flex={1} justifyContent="center" ph={4}>
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'WHITE'} ellipsizeMode={'tail'} numberOfLines={1}>
              {rowData.initiatorName}
            </Text>
            <Text fontFamily={'jiotype-medium'} fontSize={10} lineHeight={20} color={'#C1C1C1' as ColorOptions}>
              {rowData.initiatorMobileNo}
            </Text>
          </Box>
        </Box>
      </Box>
    )
  }
  const renderModal = () => {
    return ReactDOM.createPortal(renderUsername(), document.body)
  }

  // const onLayout = (evt: any) => {
  //   pos.current = { left: evt?.nativeEvent?.layout?.left, top: evt?.nativeEvent?.layout?.top }
  // }
  const onPress = () => {
    parentViewRef.current?.measure((_fx, _fy, _width, _height, px, py) => {
      pos.current = { left: px, top: py }
      setHoverViewVisible(!hoverViewVisible)
    })
  }

  return (
    <Box
      {...bgStyle}
      ref={parentViewRef}
      testID="hover-visible"
      onPress={() => data === 'MANUAL' && onPress()}
      underlayColor={'TRANSPARENT'}>
      {hoverViewVisible && renderModal()}
      <Text {...textStyles} color={bgStyle.color as ColorOptions} title={data} />
    </Box>
  )
}
